import {EVENTS_NAME} from './config.js'

export const getReservationEvents = ({event, properties}) => {
  const reservationEvents = []

  if (
    event === EVENTS_NAME.RESERVATION_START_CLICKED_DETAIL.EVENT &&
    properties.hit_origin === EVENTS_NAME.RESERVATION_START_CLICKED_DETAIL.HIT_ORIGIN
  ) {
    reservationEvents.push(EVENTS_NAME.RESERVATION_START_CLICKED_DETAIL.EVENT_OPTIMIZELY)
  }

  if (
    event === EVENTS_NAME.RESERVATION_MORE_INFORMATION_CLICKED_DETAIL.EVENT &&
    properties.hit_origin === EVENTS_NAME.RESERVATION_MORE_INFORMATION_CLICKED_DETAIL.HIT_ORIGIN
  ) {
    reservationEvents.push(EVENTS_NAME.RESERVATION_MORE_INFORMATION_CLICKED_DETAIL.EVENT_OPTIMIZELY)
  }

  return reservationEvents
}
